<template>
	<el-dialog title="取消预约" width="500px" :visible.sync="dialogVisible" :show-close="true"
			   :close-on-click-modal="false" :close-on-press-escape="false">
		<div class="update-cancel" v-loading="loading">
			<div class="head" v-if="notices">
				取消须知：
				<template v-for="(item, index) in notices">
					<div :key="'notice_'+index">
						{{ item.itemDesc }}
					</div>
				</template>
			</div>
			<div v-if="payState===1">
				<p>取消原因：</p>
				<el-input type="textarea" v-model="reason"></el-input>
			</div>
			<div>
				<el-button size="mini" type="primary" @click="dialogVisible = false">退出</el-button>
				<el-button size="mini" type="primary" @click="submit()" v-if="payState===1">仍要取消</el-button>
        <el-button size="mini" type="primary" @click="cancelNoPay()" v-if="payState===0">仍要取消</el-button>
      </div>
		</div>
	</el-dialog>
</template>

<script>
    import base from '@/api/common';
    import { getAxios, putAxios } from "@/api/http";

    export default {
        name: "cancel-appoint",
        data() {
            return {
                notices: [],
                dialogVisible: false,
                loading: false,
                appointId: -999,
                reason: '',
                isPay: 0, // 0: 未支付, 1: 已支付
                payState: 0,
            }
        },
        methods: {
            async initData(id, payState) {
                let vm = this;
                vm.appointId = id;
                vm.getNotices();
                vm.dialogVisible = true;
                vm.payState = payState
            },
            submit() {
                let vm = this;
                vm.loading = true;
                if ($.trim(vm.reason).length == 0) {
                    vm.$message.warning('请先输入取消原因');
                    vm.loading = false;
                    return false;
                }
                let params = {
                    reason: vm.reason
                };
                putAxios(base.api.appoint.cancel.replace("{id}", vm.appointId) + "?" + $.param(params))
                    .then((res) => {
                        if (res.data.status == 'success') {
                            vm.$message.success({
                                message: res.data.message, onClose: _ => {
                                    vm.dialogVisible = false;
                                    vm.$parent.reload();
                                }
                            })
                        } else {
                            vm.$message.error({
                                message: res.data.message, onClose: _ => {
                                    vm.dialogVisible = false;
                                    vm.$parent.reload();
                                }
                            })
                        }
                    }).catch((err) => {
                  console.error(err);
                  vm.$message.error('操作失败');
                })
            },
            getNotices() {
                let vm = this;
                getAxios(base.api.dict.appoint.cancel)
                    .then((res) => {
                        if (res.data.status == 'success') {
                            vm.notices = res.data.list;
                        }
                    });
            },
            cancelNoPay() {
              let that = this;
              this.$ajax.get(base.api.appoint.cancelNoPay.replace("{id}", this.appointId)).then((res) => {
                if (res.data.status === "success") {
                  that.$message.success({
                    message: "操作成功", onClose: _ => {
                      that.dialogVisible = false;
                      that.$parent.reload();
                    }
                  })
                } else {
                  that.$message.error(res.data.message);
                }
              }).catch((err) => {
                console.error(err);
                that.$message.error("操作异常");
              })
            }
        }
    }
</script>

<style scoped>

</style>
